import { noop } from 'lodash';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { SigningStatus } from '@dreryk/egabinet-truststore-published-language-api';

import { TranslatableText } from '@dreryk/react-common';
import { dispatchSnackbarWarningEvent, Link } from '@dreryk/react-components';

import { translationKeys } from '../translations';

const CERTIFICATE_PATH = 'moje-konto/certyfikat';

const dispatchInvalidCertificateSnackbarWarningEvent = (text: TranslatableText | ReactElement): void => {
   dispatchSnackbarWarningEvent(text, {
      autoHideDelayInMs: 10000,
   });
};

type MedicalDocumentSigningStatusHandler = (signingStatus: SigningStatus | undefined) => void;

export const useMedicalDocumentSigningStatusHandler = (): MedicalDocumentSigningStatusHandler => {
   return (signingStatus: SigningStatus | undefined): void => {
      switch (signingStatus) {
         case 'FAILURE_DUE_TO_NO_VALID_CERTIFICATE_FOUND':
            return dispatchInvalidCertificateSnackbarWarningEvent(
               <Trans
                  i18nKey={translationKeys.noValidPersonalCertificateWarning}
                  components={{
                     link: (
                        <Link
                           testId={'myCertificate'}
                           label={translationKeys.myAccount}
                           href={CERTIFICATE_PATH}
                           block={false}
                        />
                     ),
                  }}
               />
            );
         case 'FAILURE_DUE_TO_UNKNOWN_REASON':
            return dispatchInvalidCertificateSnackbarWarningEvent(translationKeys.invalidCertificateWarning);
         default:
            return noop();
      }
   };
};
